import Model from '@/models/Model'
import ParagraphModel from '@/models/ParagraphModel'

export default class JobModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get title () {
    return this.get('attributes.title')
  }

  get paragraphs () {

    const ps = this.get('rel.job_paragraph_content')
    if (!ps) return [] // au cas ou il n'y est aucun paragraph
    return ps.map((p) => { return new ParagraphModel(p, this._included) })
  }

  get derivatives () {
    return this.get('rel.cover_visual.rel.field_image.links')
  }
}
